<template>
<b-container>
    <div class="body-wrapper">
        <div class="body-title">
            <h5 style="color:#2284ab">Profile info</h5>
        </div>
        <div class="body-content">
            <b-row class="mb-2">
                <b-col md="6" >
                    
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
                        <b-input-group-append>
                        <b-btn :disabled="!filter" @click="filter = ''"  size="sm">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    
                </b-col>
                <b-col md="6" >
                    <b-form-group horizontal label="Sort" class="mb-0" label-size="sm">
                    <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions"  size="sm">
                        <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-input-group-append>
                        <b-form-select :disabled="!sortBy" v-model="sortDesc"  size="sm">
                            <option :value="false">Asc</option>
                            <option :value="true">Desc</option>
                        </b-form-select>
                        </b-input-group-append>
                    </b-input-group>
                    </b-form-group>
                </b-col>
            
            </b-row>

              <!-- Main table element -->
          <b-table show-empty head-variant="dark"
                      stacked="md"
                      bordered
                      striped
                      :items="form.UserApplication"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      @filtered="onFiltered"
                      style="font-size:12px"
                     
          >

              <template slot="actions" slot-scope="row">
                  <b-button size="sm" @click.stop="viewApplication(row.item, row.index, $event.target)" 
                      class="mr-1 pt-0 pb-0" variant="link" v-b-tooltip.hover title="View Application">
                      <i class="fa fa-eye" style="font-size:16px;color:blue"></i>
                  </b-button>
                   <b-button 
                   size="sm" @click.stop="get_report()" 
                      class="mr-1 pt-0 pb-0" variant="link" v-b-tooltip.hover title="Edit Application">
                      <i class="fa fa-edit" style="font-size:16px;color:blue"></i>
                  </b-button>
                  
              </template>
              <template slot="row-details" slot-scope="row">
                  <b-card>
                    <span>{{row.item.description}}</span>
                  </b-card>
              </template>
              </b-table>
              <b-row>
                  <b-col md="8" class="my-1">
                  <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"  size="sm"/>
              </b-col>
              <b-col md="4" class="my-1">
                  <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
                  <b-form-select :options="pageOptions" v-model="perPage"  size="sm" />
                  </b-form-group>
              </b-col>
          </b-row>
        </div>
    </div>
    <b-modal id="modal1" title="PrintModal" size="lg">
        <div class="application-view">
            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Personal Details
                </h5>
                <div class="reg-form-body">
                    <div class="row">
                        <div class="col-md-8">
                            <div class='row'>
                                <div class='col-md-4'>Registration No :</div>
                                <div class="col-md-8">
                                    {{RegNo}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Full Name :</div>
                                <div class="col-md-8">
                                    {{FullName}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Address :</div>
                                <div class="col-md-8">
                                    {{Add}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Gender :</div>
                                <div class="col-md-8">
                                    {{Gender}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Birth Date :</div>
                                <div class="col-md-8">
                                    {{BirthDate}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Place of Birth  :</div>
                                <div class="col-md-8">
                                    {{PlaceOfBirth}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Email Id</div>
                                <div class="col-md-8">
                                    {{EmailId}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Mobile No;</div>
                                <div class="col-md-8">
                                    {{Mobile}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>PanCard No</div>
                                <div class="col-md-8">
                                    {{PanCard}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Adhar Card No</div>
                                <div class="col-md-8">
                                    {{Adhar}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Mother Name</div>
                                <div class="col-md-8">
                                    {{Mother}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Married Status</div>
                                <div class="col-md-8">
                                    {{Married}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Natianality</div>
                                <div class="col-md-8">
                                    {{Nationality}}
                                </div>
                            </div>
                            <div class='row'>
                                <div class='col-md-4'>Maharashtra Domiciled</div>
                                <div class="col-md-8">
                                    {{Domicile}}
                                </div>
                            </div>

                        </div>
                        <div class="col-md-4">
                            <!-- <asp:Image ImageUrl="http://13.232.158.247/Images/Akash%20Rane_WebCam.png" Width="150px" ID="profileImage" runat="server" /> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Religion/ Category
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>Religion</div>
                        <div class="col-md-8">
                            {{Religion}}
                        </div>
                    </div>

                    <div class='row'>
                        <div class='col-md-4'>Category</div>
                        <div class="col-md-8">
                            {{Category}}
                        </div>
                    </div>

                    <div class='row'>
                        <div class='col-md-4'>Sub-Caste</div>
                        <div class="col-md-8">
                            {{SubCaste}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Employment Exchange Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>Whether registered in Employment Exchange?*</div>
                        <div class="col-md-8">
                            {{EmpExch}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Employment Exchange Name</div>
                        <div class="col-md-8">
                            {{EmpExchName}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Employment Exchange Registration No :</div>
                        <div class="col-md-8">
                            {{EnoExchReg}}
                        </div>
                    </div>
                </div>
            </div>


            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Permanent Address Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>House No:</div>
                        <div class="col-md-8">
                            {{HouseNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Building No</div>
                        <div class="col-md-8">
                            {{BldgNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Landmark</div>
                        <div class="col-md-8">
                            {{Landmark}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>State</div>
                        <div class="col-md-8">
                            {{State}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>District</div>
                        <div class="col-md-8">
                            {{Dist}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Taluka</div>
                        <div class="col-md-8">
                            {{Tal}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Village</div>
                        <div class="col-md-8">
                            {{Village}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Pincode</div>
                        <div class="col-md-8">
                            {{Pincode}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Residing Since</div>
                        <div class="col-md-8">
                            {{ResidingSince}}
                        </div>
                    </div>
                </div>
            </div>


            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Physical Detail
                </h5>
                <div class="reg-form-body">
                    <table class="table table-sm">
                        <tr>
                            <th>Height(cm)</th>
                            <th>Weight(kg)</th>
                            <th>Chest Deflated</th>
                            <th>Chest Inflated</th>
                        </tr>
                        <tr>
                            <td>
                                {{Height}}
                            </td>
                            <td>
                                {{Weight}}
                            </td>
                            <td>
                                {{ChestDefl}}
                            </td>
                            <td>
                                {{ChestInfl}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>


            <div class="reg-form-box empdet">
                <h5 class="reg-form-title text-primary">Employer Details
                </h5>
                <div class="reg-form-body">
                    <div class='row'>
                        <div class='col-md-4'>Working Status:</div>
                        <div class="col-md-8">
                            {{WorkingStat}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Name of Agency</div>
                        <div class="col-md-8">
                            {{NameOfAgency}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Address</div>
                        <div class="col-md-8">
                            {{AgencyAdd}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Location Of Work Place</div>
                        <div class="col-md-8">
                            {{LocWork}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Nature of Appointment</div>
                        <div class="col-md-8">
                            {{Appointment}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>PF NO</div>
                        <div class="col-md-8">
                            {{PFNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>ESIC NO</div>
                        <div class="col-md-8">
                            {{ESICNo}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Basic Pay</div>
                        <div class="col-md-8">
                            {{Basic}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>DA</div>
                        <div class="col-md-8">
                            {{DA}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Total Salary</div>
                        <div class="col-md-8">
                            {{TotalSal}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Date Of Joining</div>
                        <div class="col-md-8">
                            {{DOJ}}
                        </div>
                    </div>
                    <div class='row'>
                        <div class='col-md-4'>Last Date of Working</div>
                        <div class="col-md-8">
                            {{LastDateWork}}
                        </div>
                    </div>
                </div>
            </div>


            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Qualification Details
                </h5>
                <div class="reg-form-body">
                    <table class="table table-sm">
                        <tr>
                            <th>Qualification Type</th>
                            <th>Name of Degree</th>
                            <th>Subject</th>
                            <th>Board / University</th>
                            <th>Class</th>
                            <th>Percentage</th>
                        </tr>
                        <tr>
                            <td>
                                {{QualType}}
                            </td>
                            <td>
                                {{Degree}}
                            </td>
                            <td>
                                {{Subject}}
                            </td>
                            <td>
                                {{Board}}
                            </td>
                            <td>
                                {{Class}}
                            </td>
                            <td>
                                {{Percentage}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="reg-form-box">
                <h5 class="reg-form-title text-primary">Documents Uploaded
                </h5>
                <div class="reg-form-body">
                    Pending Confirm UI
                </div>
            </div>
        
        </div>
        <b-btn @click="hideModal">Close Me</b-btn>
        <button v-print="'#printMe'">Print Application</button>
    </b-modal>
</b-container>
</template>

<script>
import Print from "vue-print-nb";
import apis from "../apis";
export default {
  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      form: {
        UserID: "",
        FullName: "",
        Gender: true,
        DOB: "",
        Age: 0,
        EmailId: "",
        MobileNo: "",
        RegistrationType: 0,
        UserApplication: []
      },
      fields: [
        { key: "EventTitle", label: "Job Title", sortable: true },
        { key: "ApplicationNo", label: "Application No.", sortable: true },
        { key: "ApplicationDate", label: "Application Date", sortable: true },
        { key: "ApplicationStatus", label: "Status" },
        { key: "show_details", label: "Details" },
        { key: "actions", label: "View" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedProductId: "",
      /*** */
      RegNo: "",
      FullName: "",
      Add: "",
      Gender: "",
      BirthDate: "",
      PlaceOfBirth: "",
      EmailId: "",
      Mobile: "",
      PanCard: "",
      Adhar: "",
      Mother: "",
      Married: "",
      Nationality: "",
      Domicile: "",
      ImageLink: "",
      Religion: "",
      Category: "",
      SubCaste: "",
      EmpExch: "",
      EmpExchName: "",
      EnoExchReg: "",
      HouseNo: "",
      BldgNo: "",
      Landmark: "",
      State: "",
      Dist: "",
      Tal: "",
      Village: "",
      Pincode: "",
      ResidingSince: "",
      Height: "",
      Weight: "",
      ChestDefl: "",
      ChestInfl: "",
      WorkingStat: "",
      NameOfAgency: "",
      AgencyAdd: "",
      LocWork: "",
      Appointment: "",
      PFNo: "",
      ESICNo: "",
      Basic: "",
      DA: "",
      TotalSal: "",
      DOJ: "",
      LastDateWork: "",
      QualType: "",
      Degree: "",
      Subject: "",
      Board: "",
      Class: "",
      Percentage: ""
      /*** */
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
     get_report() {
        
      this.$router.push("/profile");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewApplication(item, index, button) {
        let appObj = {
            BoardName: item.BoardName,
            JobTitle: item.EventTitle,
            ApplicationNo: item.ApplicationNo,
            ApplicationDate: item.ApplicationDate
        }
        this.$store.dispatch('setApplicationObj', appObj);
        this.$router.push({
                  name: "ViewProfile",
                  params: { eventid: item.EventID }
                });
      this.$root.$emit("bv::show::modal", "PrintModal");
    },
    hideModal() {
      this.$root.$emit("bv::hide::modal", "PrintModal");
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    var UserId = userinfo.UserId;
    let promise = apis.getUserApplications(UserId);

    promise.then(response => {
      if (response.status == 200) {
        this.form = response.body[0];
        this.totalRows = this.form.UserApplication.length;
      }
    });
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}

.reg-form-box .btn {
  border-radius: 2px;
}

.reg-form-box {
  padding: 10px 10px;
}

.reg-form-box .reg-form-body {
  border: solid thin #e0e0e1;
  padding: 15px 25px;
  font-size: 11pt;
}

.reg-form-box .reg-form-body .col {
  padding: 10px 8px !important;
}

.reg-form-box .reg-form-body .form-control {
  font-size: 10pt !important;
  padding: 5px 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewApplication.vue